import { Base } from '../base-component';
import './accolades-carousel-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from 'services/media-query.service';

export class AccoladesCarouselItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}


// WEBPACK FOOTER //
// ./components/accolades-carousel-item/accolades-carousel-item.component.ts